import React from 'react';
import { Leaf, Truck, UserCheck, ShieldCheck } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { useStore } from '../../context/StoreContext';

const DEFAULT_ICONS = [Leaf, Truck, UserCheck, ShieldCheck];
const DEFAULT_COLORS = [
  'text-emerald-700 bg-emerald-100',
  'text-amber-700 bg-amber-100',
  'text-blue-700 bg-blue-100',
  'text-purple-700 bg-purple-100',
];

const TrustBadges = () => {
  const { lang, t } = useLanguage();
  const { cmsContent } = useStore();

  const badgesList = (cmsContent?.trustBadges && cmsContent.trustBadges.length > 0)
    ? cmsContent.trustBadges
    : [
        { titleUrdu: t('badge1Title'), descUrdu: t('badge1Desc'), titleEn: '100% Pure', descEn: 'Organic herbs' },
        { titleUrdu: t('badge2Title'), descUrdu: t('badge2Desc'), titleEn: 'Nationwide Delivery', descEn: 'Fast & secure shipping' },
        { titleUrdu: t('badge3Title'), descUrdu: t('badge3Desc'), titleEn: 'Expert Consultation', descEn: 'Free WhatsApp advice' },
        { titleUrdu: t('badge4Title'), descUrdu: t('badge4Desc'), titleEn: 'Hygienic Packaging', descEn: 'Air-tight sealed packs' },
      ];

  const badges = badgesList.map((b, idx) => ({
    icon: DEFAULT_ICONS[idx % DEFAULT_ICONS.length],
    title: lang === 'ur' ? (b.titleUrdu || b.title) : (b.titleEn || b.title),
    desc: lang === 'ur' ? (b.descUrdu || b.desc) : (b.descEn || b.desc),
    color: DEFAULT_COLORS[idx % DEFAULT_COLORS.length],
  }));

  return (
    <section className="py-8 bg-white border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {badges.map((badge, idx) => {
            const Icon = badge.icon;
            return (
              <div
                key={idx}
                className="flex items-center gap-4 p-4 rounded-2xl bg-gray-50/70 border border-gray-100 hover:border-pansar-200 transition-all hover:shadow-sm"
              >
                <div className={`w-12 h-12 rounded-xl flex items-center justify-center shrink-0 ${badge.color}`}>
                  <Icon className="w-6 h-6" />
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 text-sm font-urdu">
                    {badge.title}
                  </h4>
                  <p className="text-xs text-gray-500 font-urdu mt-0.5 leading-relaxed">
                    {badge.desc}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;
